import {
  ModalFrame
} from "./chunk-KOQJG44Q.mjs";

// lib/components/modal/base/base-dialog.tsx
import { jsx } from "@emotion/react/jsx-runtime";
var BaseDialog = ({ title, description, isActive, footer, onClose }) => /* @__PURE__ */ jsx(
  ModalFrame,
  {
    isActive,
    isLarge: false,
    title,
    body: description,
    footer,
    onClose
  }
);

export {
  BaseDialog
};
